/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { LogoListSectionFragment } from "@cosmos/hygraph-schema";

import {
	BackgroundContainer,
	LogoMarquee,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
} from "@components/elements";
import { Box, VStack } from "@panda/jsx";

export interface LogoListSectionProps extends LogoListSectionFragment {
	className?: string;
}

export const LogoListSection = (props: LogoListSectionProps): React.JSX.Element | null => {
	const { config, logos, className, disableMarquee } = props || {};
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(logos?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer className={className} disable={!disableMarquee}>
				<SectionContainer
					disablePaddingInline={!disableMarquee}
					disablePaddingBlockEnd={!!config?.disablePaddingBottom}
				>
					<VStack gap="eds.dimension.96" className="logo-list-section">
						{validHeading ? (
							<>
								<Box smDown={{ paddingInline: "eds.dimension.24" }}>
									<SectionHeading {...config?.heading} />
								</Box>
								<LogoMarquee {...props} />
							</>
						) : (
							<LogoMarquee {...props} />
						)}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
